import React from 'react';
import update from 'react-addons-update';
import PropTypes from 'prop-types';
import { Form, Button, Modal, ModalBody, Input, Col } from 'reactstrap';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../assets/styles/style.sass';
import s2 from './login.sass';
import setting from '../../assets/default/setting/general/setting.json';
import RegisterButton from './LoginButton/RegisterButton';
import LoginButton from './LoginButton/LoginButton';
import LoginModuleRedirectText from './LoginModuleRedirectText';
import {
  login,
  setUserPhone,
  setIsShowUpdateUserModal,
} from '../../actions/user';
import { returnLocaleText } from '../../service/util';
import imgMail from '../../assets/img/icon_mail.png';
import imgMail2 from '../../assets/img/icon_mail@2x.png';
import imgPhone from '../../assets/img/icon_phone.png';
import imgPhone2 from '../../assets/img/icon_phone@2x.png';
import imgName from '../../assets/img/icon_avatar.png';
import imgName2 from '../../assets/img/icon_avatar@2x.png';

class UpdateUserInfoModule extends React.Component {
  static propTypes = {
    email: PropTypes.string,
    name: PropTypes.string.isRequired,
    isShowUpdateUserModal: PropTypes.bool.isRequired,
    currentLocale: PropTypes.string.isRequired,
    setIsShowUpdateUserModal: PropTypes.func.isRequired,
    setUserPhone: PropTypes.func.isRequired,
  };
  static defaultProps = {
    email: '',
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      user: {
        phone: '',
      },
      isClickButton: false,
      tooltipOpen: false,
      errorCode: 0,
      modelDataDefaultLocale: require(`../../assets/json/default/setting/general/locale.json`),
      modelDataLocale: require(`../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
      errorMessageLocale: require(`../../assets/src/${lang}/scripts/components/setting.json`),
    };
    this.setErrorCode = this.setErrorCode.bind(this);
    this.onClickisClickButton = this.onClickisClickButton.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.isClickButton) {
      const phone = document.getElementById('phone');
      const errorMessage = this.state.errorMessageLocale[
        this.props.currentLocale
      ];

      // const phonePatt = new RegExp(this.state.errorMessageLocale.PHONE_REGEX);
      if (phone.value === '') {
        phone.setCustomValidity(errorMessage.blank_field);
        this.setErrorCode(0);
      } else {
        phone.setCustomValidity('');
      }
      this.onClickisClickButton();
    }
  }

  onClickisClickButton() {
    this.setState({ isClickButton: !this.state.isClickButton });
  }

  setPhone(e) {
    // if (Number.isNaN(e.target.value)) {
    this.props.setUserPhone(e.target.value);
    // }
    // console.warn(e.target.value);
    this.updateStateItem('phone', e.target.value);
  }

  setErrorCode(code) {
    this.setState({ errorCode: code });
  }

  updateStateItem(item, value) {
    this.setState({
      user: update(this.state.user, { [item]: { $set: value } }),
    });
  }

  toggle() {
    this.props.setIsShowUpdateUserModal();
  }

  tooltipToggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <Modal
          isOpen={this.props.isShowUpdateUserModal}
          toggle={() => this.toggle()}
          className={`${s2.resizeModal} text-center`}
          contentClassName={s2.resizeModalContent2}
          style={{ backgroundColor: '#f7f7f7 !important' }}
        >
          <Button
            outline
            color="link"
            onClick={() => this.toggle()}
            className={`${s2.infoCloseRightButton}`}
          />
          <ModalBody>
            <div
              className={`${
                this.state.errorCode !== 0 ? s.dialogErrorMessage : ''
              } col-11`}
            >
              <p>
                {this.state.errorCode === 401 ? (
                  <small className="error-normal">
                    {returnLocaleText(
                      this.state.modelDataLocale
                        .error_message_login_info_incorrect,
                      this.state.modelDataDefaultLocale
                        .error_message_login_info_incorrect,
                    )}
                  </small>
                ) : (
                  ''
                )}
                {this.state.errorCode === 1 ? (
                  <small className="error-normal">
                    {returnLocaleText(
                      this.state.modelDataLocale
                        .error_message_password_length_not_enough,
                      this.state.modelDataDefaultLocale
                        .error_message_password_length_not_enough,
                    )}
                  </small>
                ) : (
                  ''
                )}
                {this.state.errorCode === 2 ? (
                  <small className="error-normal">
                    {returnLocaleText(
                      this.state.modelDataLocale
                        .error_message_password_not_match,
                      this.state.modelDataDefaultLocale
                        .error_message_password_not_match,
                    )}
                  </small>
                ) : (
                  ''
                )}
                {this.state.errorCode === 4 ? (
                  <small className="error-normal">
                    {returnLocaleText(
                      this.state.modelDataLocale
                        .error_message_please_enter_telephone_number,
                      this.state.modelDataDefaultLocale
                        .error_message_please_enter_telephone_number,
                    )}
                  </small>
                ) : (
                  ''
                )}
                {this.state.errorCode === 7 ? (
                  <small className="error-normal">
                    {returnLocaleText(
                      this.state.modelDataLocale
                        .error_message_telephone_number_in_use,
                      this.state.modelDataDefaultLocale
                        .error_message_telephone_number_in_use,
                    )}
                  </small>
                ) : (
                  ''
                )}
              </p>
            </div>
            <h2 className={s2.registerTitle}>
              {returnLocaleText(
                this.state.modelDataLocale.update_profile_modal_title,
                this.state.modelDataDefaultLocale.update_profile_modal_title,
              )}
            </h2>
            <Form
              className={`${s.loginForm}`}
              data-type="login"
              action=""
              onSubmit={e => {
                e.preventDefault();
                return false;
              }}
            >
              <Col
                md={{ size: 8, offset: 2 }}
                sm={{ size: 8, offset: 2 }}
                xs={{ size: 12 }}
                className={s2.inputPadding}
              >
                <input
                  className={s2.input}
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}"
                  type="email"
                  placeholder="Email"
                  id="email"
                  name="email"
                  value={this.props.email}
                  onChange={this.setEmail}
                  disabled
                />
              </Col>
              <Col
                md={{ size: 8, offset: 2 }}
                sm={{ size: 8, offset: 2 }}
                xs={{ size: 12 }}
                className={s2.inputPadding}
              >
                <input
                  className={s2.input}
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Name"
                  value={this.props.name}
                  onChange={this.setName}
                  disabled
                />
              </Col>
              <Col
                md={{ size: 8, offset: 2 }}
                sm={{ size: 8, offset: 2 }}
                xs={{ size: 12 }}
                className={s2.inputPadding}
              >
                <input
                  className={s2.input}
                  type="text"
                  id="phone"
                  name="phone"
                  placeholder="Phone"
                  value={this.state.user.phone}
                  onChange={e => {
                    this.setPhone(e);
                  }}
                  required
                />
              </Col>
              <Col
                md={{ size: 8, offset: 2 }}
                sm={{ size: 8, offset: 2 }}
                xs={{ size: 12 }}
                className={s2.inputPadding}
              >
                {setting.login_facebook ? (
                  <div>
                    <RegisterButton
                      user={this.state.user}
                      tooltipToggle={this.tooltipToggle}
                      setErrorCode={this.setErrorCode}
                      toggle={this.toggle}
                      getEmail={this.getEmail}
                      getPassword={this.getPassword}
                      onClickisClickButton={this.onClickisClickButton}
                      isFromUpdateUserInfoModal
                      text={returnLocaleText(
                        this.state.modelDataLocale.register_modal_register_btn,
                        this.state.modelDataDefaultLocale
                          .register_modal_register_btn,
                      )}
                    />
                  </div>
                ) : (
                  <LoginButton />
                )}
                <div className={s2.orLine}>
                  <hr />
                  <span
                    className={s2.or}
                    style={{ backgroundColor: '#f7f7f7' }}
                  >
                    {returnLocaleText(
                      this.state.modelDataLocale.register_modal_or,
                      this.state.modelDataDefaultLocale.register_modal_or,
                    )}
                  </span>
                </div>
              </Col>
            </Form>
            <span className={`${s.globalFontLight} ${s2.registerIfNotYet}`}>
              <LoginModuleRedirectText
                target="#register"
                normalText={returnLocaleText(
                  this.state.modelDataLocale.register_modal_normal_message,
                  this.state.modelDataDefaultLocale
                    .register_modal_normal_message,
                )}
                btnText={returnLocaleText(
                  this.state.modelDataLocale
                    .register_modal_redirect_to_login_btn,
                  this.state.modelDataDefaultLocale
                    .register_modal_redirect_to_login_btn,
                )}
              />
            </span>
          </ModalBody>
        </Modal>
      </span>
    );
  }
}
const mapState = state => ({
  email: state.user.email,
  password: state.user.password,
  name: state.user.name,
  currentLocale: state.intl.locale,
  isShowUpdateUserModal: state.user.isShowUpdateUserModal,
});

const mapDispatch = {
  login,
  setUserPhone,
  setIsShowUpdateUserModal,
};

export default connect(mapState, mapDispatch)(
  withStyles(s, s2)(UpdateUserInfoModule),
);



// WEBPACK FOOTER //
// ./src/components/Login/UpdateUserInfoModule.js